import React, { useEffect } from 'react';
import { useCatalogs } from '../../hooks/useCatalogs';
import styles from './ListingPageCarousel.module.css';

export default function ListingPageCarousel() {
  const { loading, error, catalogs } = useCatalogs(true);

  useEffect(() => {
    try { console.info('[ListingPageCarousel/component] Mounted component ListingPageCarousel'); } catch(_) {}
  }, []);

  if (loading || error) return null;

  const featured = (catalogs?.liquor || []).slice(0, 12);
  if (!featured.length) return null;

  return (
    <section
      className={styles.wrapper}
      data-component="listing-page-carousel-component"
      aria-label="Featured spirits carousel"
    >
      <div className={styles.carousel} role="list">
        {featured.map(item => (
          <article
            key={item.sku || item.id}
            className={styles.card}
            role="listitem"
            aria-label={item.name}
          >
            <div className={styles.imageWrapper}>
              {item.imageUrl ? (
                <img
                  src={item.imageUrl}
                  alt={item.name}
                  loading="lazy"
                  decoding="async"
                  onError={e => { e.currentTarget.style.visibility = 'hidden'; }}
                />
              ) : null}
            </div>
            <div className={styles.title}>{item.name}</div>
          </article>
        ))}
      </div>
    </section>
  );
}
